import React from "react";

export declare type EventName = "willShow" | "willHide";

export interface MenuContextProps {
  showMenu: () => void;
  hideMenu: () => void;
}
export const MenuContext = React.createContext<MenuContextProps>({
  showMenu: () => {
    console.warn("MenuProvider not implemented");
  },
  hideMenu: () => {
    console.warn("MenuProvider not implemented");
  },
});

export const useMenu = () => {
  return React.useContext(MenuContext);
};
